import { render, staticRenderFns } from "./AuditCriteria.vue?vue&type=template&id=2afdb28c&"
import script from "./AuditCriteria.vue?vue&type=script&lang=js&"
export * from "./AuditCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports